import axiosInstance from './axios';

export const eventService = {
  getAllEvents: () => axiosInstance.get('/api/events'),
  getEvent: (id) => axiosInstance.get(`/api/events/${id}`),
  createEvent: (data) => axiosInstance.post('/api/events', data),
  updateEvent: (id, data) => axiosInstance.put(`/api/events/${id}`, data),
  deleteEvent: (id) => axiosInstance.delete(`/api/events/${id}`)
};
